import { render, staticRenderFns } from "./Viewpage.vue?vue&type=template&id=767e78eb&"
import script from "./Viewpage.vue?vue&type=script&lang=js&"
export * from "./Viewpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports